import { hashTagsService } from "motw_core/Services/HashTagsService";
import { DreamEditor } from "../DreamEditor";
import { SetStateMultiple } from "source/app/services/UI/State/SetState";
import { ESharedFunctionMultiple } from "motw_core/Enums/ESharedFunction";

let closeHashTagsTimer: number | undefined;
const closeHashTagsDelayMs = 3000;

export function HandleDreamEditorHashtagClicked(
    DreamEditor: DreamEditor,
    hashTag: string,
    chevronPanelId: string
) {
    const currentDreamName = DreamEditor.state.dream.name;

    const withoutHashTag = hashTagsService.GetStringWithoutHashTag(
        currentDreamName,
        hashTag
    );

    const withHashTag = hashTagsService.GetStringWithHashTag(
        withoutHashTag,
        hashTag
    );

    const doesDreamHaveHashTag = hashTagsService.DoesDreamHaveHashTag(
        DreamEditor.state.dream,
        hashTag
    );

    const newDreamName = doesDreamHaveHashTag ? withoutHashTag : withHashTag;
    const finalDreamName = newDreamName.replaceAll(`# `, ``);

    const updatedDream = {
        ...DreamEditor.state.dream,
        name: finalDreamName,
    };

    DreamEditor.setState({ dream: updatedDream });

    CloseHashTagsAfterDelay(chevronPanelId);
}

function CloseHashTagsAfterDelay(chevronPanelId: string) {
    if (closeHashTagsTimer !== undefined) {
        window.clearTimeout(closeHashTagsTimer);
    }

    closeHashTagsTimer = window.setTimeout(() => {
        SetStateMultiple(
            ESharedFunctionMultiple.ChevronPanel_isOpen,
            chevronPanelId,
            false
        );
    }, closeHashTagsDelayMs);
}
